import { get, post, put, del, exportExcel } from "./http";
import { BaseUrlNew } from "./NewSiteUrl";
import { headerDemo } from "./editHeader";

/** ******************** 城市合伙人 ******************** */

// 查询列表
export const getCityPartnerPaginationList = params =>get( BaseUrlNew + "/api/cityPartner/pagination",params, 1);
// 根据城市合伙人Id查询合伙人详情
export const getCityPartnerDetails = params =>get( BaseUrlNew + "/api/cityPartner",params, 1);
// 查询合伙人提现记录
export const getWithdrawRecord = params =>get( BaseUrlNew + "/api/cityPartner/withdraw-record",params, 1);
// 查询合伙人推广人员
export const getCityPartnerBD = params =>get( BaseUrlNew + "/api/cityPartner/bd",params, 1);
// 查询合伙人入驻企业
export const getEnterprise = params =>get( BaseUrlNew + "/api/cityPartner/enterprise",params, 1);
// 新增城市合伙人
export const postCityPartner = params =>post( BaseUrlNew + "/api/cityPartner",params, headerDemo, 1);
// 添加合伙人入驻城市下拉数据
export const getSettledCityList = params =>get( BaseUrlNew + "/api/cityPartner/settledCity",params, 1);
// 报价查询品类
export const SelectGoodsBrandTypeByFirstLetter = params =>post("/bdService/BaseData/SelectGoodsBrandTypeByFirstLetter",params)
// 获取城市合伙人信息
export const getinfoId = (params, newId) =>get( BaseUrlNew + "/api/cityPartner/getinfo/"+newId,params, 1);

/** ******************** 入驻企业 ******************** */

// 查询企业列表
export const getEnterprisePagination = params =>get( BaseUrlNew + "/api/enterprise/pagination",params, 1);
// 查询企业详情
export const getEnterpriseDetails = params =>get( BaseUrlNew + "/api/enterprise",params, 1);
// 查询企业提现记录
export const getEnterpriseWithdrawRecord = params =>get( BaseUrlNew + "/api/enterprise/withdraw-record",params, 1);
// 查询企业品牌店
export const getStoreList = params =>get( BaseUrlNew + "/api/enterprise/store",params, 1);
// 查询企业资质
export const getQualification = params =>get( BaseUrlNew + "/api/enterprise/qualification",params, 1);
// 审核企业
export const putEnterprise = params =>put( BaseUrlNew + "/api/enterprise",params, headerDemo, 1);
// 编辑入驻商家信息
export const editEnterprise = params =>post( BaseUrlNew + "/api/enterprise/edit",params, headerDemo, 1);


/** ******************** 品牌店铺 ******************** */

// 品牌店铺列表
export const getpaginationList = params =>get( BaseUrlNew + "/api/brandBusiness/pagination",params, 1);
// 品牌店铺详情
export const getDetails = params =>get( BaseUrlNew + "/api/brandBusiness/details",params, 1);
// 添加品牌店铺
export const postDetails = params =>post( BaseUrlNew + "/api/brandBusiness",params, headerDemo, 1);
// 保存品牌店铺
export const putDetails = params =>put( BaseUrlNew + "/api/brandBusiness",params, headerDemo, 1);
//品牌商管理-设置店铺等级
export const BrandBusinessSetType = params =>put( BaseUrlNew + "/api/brandBusiness/setType",params, headerDemo, 1, '4.0');
//品牌商管理-获取品牌商有效等级
export const getEffectiveType = params =>get( BaseUrlNew + "/api/brandBusiness/effectiveType",params, 1, '4.0');


/** ******************** 店铺管理 ******************** */

// 添加店铺
export const newPostBrandBusiness = params =>post( BaseUrlNew + "/api/brandBusiness",params, headerDemo, 1, '2.0');
// 修改店铺
export const newPutBrandBusiness = params =>put( BaseUrlNew + "/api/brandBusiness",params, headerDemo, 1, '2.0');
// 店铺详情
export const newGetBrandBusiness = params =>get( BaseUrlNew + "/api/brandBusiness",params, 1, '2.0');
// 装修公司服务标识
export const newGetDcService = params =>get( BaseUrlNew + "/api/brandBusiness/dcService",params, 1, '1.0');
// 获取员工企业类型
export const newGetStaffEnterprise = params =>get( BaseUrlNew + "/api/brandBusiness/staffEnterprise",params, 1, '1.0');
// 是否显示添加店铺按钮 & 添加店铺数量限制
export const getShowAddShopButton = params =>get( BaseUrlNew + "/api/staff/back/showAddShopButton",params, 1, '1.0');
// 付费推广数据开关
export const openPaidPromotionData = (params, newId) =>put( BaseUrlNew + "/api/brandBusiness/openPaidPromotionData?bbid=" + newId,params, headerDemo, 1);
// 获取用户身份
export const jurisdiction = params =>get( BaseUrlNew + "/api/account/jurisdiction",params, 1, '1.0');

// 获取店铺简介
export const intro = (params, shopId) => get(BaseUrlNew + "/api/brandBusiness/intro/" + shopId, params, 1, '1.0');
// 保存店铺简介(新增/编辑)
export const introsave = params => post(BaseUrlNew + "/api/brandBusiness/intro/save", params, headerDemo, 1, '1.0');


/** ******************** 余额提现管理 ******************** */

// 查询用户提现记录列表
export const getWithdraw = params =>get( BaseUrlNew + "/api/withdraw",params, 1);
// 查询用户提现记录详情
export const getWithdrawDetail = params =>get( BaseUrlNew + "/api/withdraw/detail",params, 1);
// 审核用户提现记录
export const putWithdraw = params =>put( BaseUrlNew + "/api/withdraw",params, headerDemo, 1);



/** ******************** 公告 ******************** */

// 查询公告列表
export const getBack = params =>get( BaseUrlNew + "/api/notice/notice/back",params, 1);
// 查询公告详情
export const getDetailBack = params =>get( BaseUrlNew + "/api/notice/detail/back",params, 1);
// 新增公告
export const postBack = params =>post( BaseUrlNew + "/api/notice/back",params, headerDemo, 1);




/** ******************** 我的联盟 ******************** */
// 店铺推广码
export const shopQRCode = params =>get( BaseUrlNew + "/api/brandBusiness/shopQRCode",params, 1);
// 店铺商圈合作品类树
export const brandTypeTree = params =>get( BaseUrlNew + "/api/brandBusiness/brandTypeTree",params, 1);
// 店铺合作列表
export const cooperationList = params =>get( BaseUrlNew + "/api/brandBusiness/cooperationList",params, 1);
// 合作保存
export const saveCooperationShop = params =>post( BaseUrlNew + "/api/brandBusiness/saveCooperationShop",params, headerDemo, 1);
// 员工列表
export const cooperationStaffList = params =>get( BaseUrlNew + "/api/brandBusiness/cooperationStaffList",params, 1);
// 删除绑定员工
export const delCooperationStaff = params =>del( BaseUrlNew + "/api/brandBusiness/delCooperationStaff",params, 1, '1.0');
// 被邀列表
export const invitedShopList = params =>get( BaseUrlNew + "/api/brandBusiness/invitedShopList",params, 1);

// 申请创建联盟
export const merchantAllianceAdd = params =>post( BaseUrlNew + "/api/merchantAlliance/add",params, headerDemo, 1);
// 联盟列表
export const merchantAllianceList = params =>get( BaseUrlNew + "/api/merchantAlliance/list",params, 1);
// 取消联盟申请
export const merchantAllianceCancel = params =>post( BaseUrlNew + "/api/merchantAlliance/cancel",params, headerDemo, 1);
// 设置主推联盟
export const settingMain = params =>post( BaseUrlNew + "/api/merchantAlliance/settingMain",params, headerDemo, 1);
// 退出联盟
export const signOut = params =>post( BaseUrlNew + "/api/merchantAlliance/signOut",params, headerDemo, 1);
// 联盟审核列表
export const examineMAList = params =>get( BaseUrlNew + "/api/merchantAlliance/examineMAList",params, 1);
// 开启或关闭数据
export const putSeeAll = params =>put( BaseUrlNew + "/api/merchantAlliance/seeAll",params, headerDemo, 1);
// 审核联盟
export const examine = params =>post( BaseUrlNew + "/api/merchantAlliance/examine",params, headerDemo, 1);
// 编辑联盟
export const merchantAllianceEdit = params =>put( BaseUrlNew + "/api/merchantAlliance/edit",params, headerDemo, 1);
// 获取邀请商家左侧树
export const merchantAllianceTree = params =>get( BaseUrlNew + "/api/merchantAlliance/tree",params, 1);
// 获取未邀请的店铺列表
export const merchantAllianceNotInMyMA = params =>get( BaseUrlNew + "/api/merchantAlliance/notInMyMA",params, 1);
// 邀请商家加入联盟
export const merchantAllianceInvitation = params =>post( BaseUrlNew + "/api/merchantAlliance/invitation",params, headerDemo, 1);
// 我的管理联盟列表
export const merchantAllianceMy = params =>get( BaseUrlNew + "/api/merchantAlliance/my",params, 1);
// 取消联盟邀请
export const cancelInvitation = params =>post( BaseUrlNew + "/api/merchantAlliance/cancelInvitation",params, headerDemo, 1);
// 移除商家
export const removeMerchant = params =>post( BaseUrlNew + "/api/merchantAlliance/removeMerchant",params, headerDemo, 1);
// 发送联盟邀请通知
export const sendInvitationMessage = params =>post( BaseUrlNew + "/api/merchantAlliance/sendInvitationMessage",params, headerDemo, 1);
// 入盟邀请列表
export const myMerchantAllianceList = params =>get( BaseUrlNew + "/api/merchantAlliance/myMerchantAllianceList",params, 1);
// 同意入盟
export const agreeJoinMA = params =>post( BaseUrlNew + "/api/merchantAlliance/agreeJoinMA",params, headerDemo, 1);
// 拒绝入盟
export const refuseJoinMA = params =>post( BaseUrlNew + "/api/merchantAlliance/refuseJoinMA",params, headerDemo, 1);
// 查看联盟基本信息
export const seeMABase = params =>get( BaseUrlNew + "/api/merchantAlliance/seeMABase",params, 1);
// 查看联盟已加入店铺列表
export const seeMAList = params =>get( BaseUrlNew + "/api/merchantAlliance/seeMAList",params, 1);
// 发送解散联盟验证码
export const sendDissolution = params =>post( BaseUrlNew + "/api/merchantAlliance/sendDissolution",params, headerDemo, 1);
// 解散联盟
export const dissolution = params =>post( BaseUrlNew + "/api/merchantAlliance/dissolution",params, headerDemo, 1);

// 商家渠道列表
// export const myChannel = params =>get( BaseUrlNew + "/api/merchantAlliance/myChannel",params, 1);
// 【后台】获取店铺渠道列表
export const myChannel = params =>get( BaseUrlNew + "/api/channel/getlist",params, 1);
// 获取未邀请进入渠道的店铺列表
export const notInMyChannel = params =>get( BaseUrlNew + "/api/merchantAlliance/notInMyChannel",params, 1);
// 【后台】获取可邀请渠道列表
export const sourceList = params =>get( BaseUrlNew + "/api/channel/source/getlist",params, 1);
// 【后台】获取可邀请渠道配置详情
export const sourceInfo = params =>get( BaseUrlNew + "/api/channel/source/getinfo",params, 1);
// 【后台】邀请渠道
export const channelInvite = params =>post( BaseUrlNew + "/api/channel/invite",params, headerDemo, 1);
// 【通用】获取已邀请的渠道佣金配置详情
export const channelGetinfo = (params,channelId,businessId) =>get( BaseUrlNew + "/api/channel/getinfo/"+channelId+'/'+businessId,params, 1);
// 【通用】渠道状态变更（接受、拒绝、退出）
export const channelChangestatus = params =>post( BaseUrlNew + "/api/channel/changestatus",params, headerDemo, 1);

// 邀请商家加入渠道
export const invitationChannel = params =>post( BaseUrlNew + "/api/merchantAlliance/invitationChannel",params, headerDemo, 1);
// 取消邀请
export const cancelInvitationChannel = params =>post( BaseUrlNew + "/api/merchantAlliance/cancelInvitationChannel",params, headerDemo, 1);
// 发送渠道邀请通知
export const sendInvitationChannelMessage = params =>post( BaseUrlNew + "/api/merchantAlliance/sendInvitationChannelMessage",params, headerDemo, 1);
// 移除渠道商家
export const removeChannelMerchant = params =>post( BaseUrlNew + "/api/merchantAlliance/removeChannelMerchant",params, headerDemo, 1);
// 被邀渠道列表
export const beInvitedChannel = params =>get( BaseUrlNew + "/api/channel/getinvitelist",params, 1);
// 同意或拒绝渠道邀请
export const agreeJoinChannel = params =>post( BaseUrlNew + "/api/merchantAlliance/agreeJoinChannel",params, headerDemo, 1);
// 退出渠道
export const signOutChannel = params =>post( BaseUrlNew + "/api/merchantAlliance/signOutChannel",params, headerDemo, 1);

// 店铺是否有已通过的联盟
export const getShopHasAlliance = params =>get( BaseUrlNew + "/api/merchantAlliance/shopHasAlliance",params, 1);

// 联盟数据统计列表
export const statisticsList = params =>get( BaseUrlNew + "/api/merchantAlliance/statisticsList",params, 1);
// 获取店铺联盟下拉框
export const bbJoinMaList = params =>get( BaseUrlNew + "/api/merchantAlliance/bbJoinMaList",params, 1);
// 统计拉新用户数或会员列表
export const statisticsewUserList = params =>get( BaseUrlNew + "/api/merchantAlliance/statisticsewUserList",params, 1);
// 获取员工维度列表
export const statisticsewStaffList = params =>get( BaseUrlNew + "/api/merchantAlliance/statisticsewStaffList",params, 1, '2.0');
// 统计员工维度拉新用户数或会员列表
export const statisticsStaffNewUserList = params =>get( BaseUrlNew + "/api/merchantAlliance/statisticsStaffNewUserList",params, 1);
// 统计订单维度列表
export const statisticsewOrderList = params =>get( BaseUrlNew + "/api/merchantAlliance/statisticsewOrderList",params, 1);
// 统计订单维度列表
export const statisticsewOrder = params =>get( BaseUrlNew + "/api/merchantAlliance/statisticsewOrder",params, 1);
// 更换联盟盟主
export const putReplaceMaster = params =>put( BaseUrlNew + "/api/merchantAlliance/replaceMaster",params, headerDemo, 1);
// 店铺数据-员工拉新列表-一级用户
export const getFirstUser = params =>get( BaseUrlNew + "/api/merchantAlliance/statisticsewStaffList/FirstUser",params, 1, '2.0');
// 店铺数据-员工拉新列表-二级用户
export const getSecondUser = params =>get( BaseUrlNew + "/api/merchantAlliance/statisticsewStaffList/SecondUser",params, 1, '2.0');
// 店铺数据-员工拉新列表-交易笔数
export const getUserOrderList = params =>get( BaseUrlNew + "/api/merchantAlliance/statisticsewStaffList/UserOrderList",params, 1, '2.0');
// 店铺数据-员工拉新列表-分享被浏览次数
export const getUserShareList = params =>get( BaseUrlNew + "/api/merchantAlliance/statisticsewStaffList/UserShareList",params, 1, '2.0');
// 店铺数据-员工拉新列表-导出
export const statisticsewStaffListExport = params =>exportExcel( BaseUrlNew + "/api/merchantAlliance/statisticsewStaffList/Export",params, '2.0');


/** ******************** 创客管理 ******************** */

// 获取创客集合
export const makergetlist = params =>post( BaseUrlNew + "/api/user/maker/getlist",params, headerDemo, 1);



/** ******************** 店铺红包 ******************** */

// 获取红包活动列表
export const activityGetlist = params =>get( BaseUrlNew + "/api/redpacket/activity/getlist",params, 1);
// 新增红包活动
export const activityAdd = params =>post( BaseUrlNew + "/api/redpacket/activity/add",params, headerDemo, 1);
// 获取红包活动详情
export const activityGetinfo = params =>get( BaseUrlNew + "/api/redpacket/activity/getinfo",params, 1);
// 编辑红包活动
export const activityEdit = params =>post( BaseUrlNew + "/api/redpacket/activity/edit",params, headerDemo, 1);
// 获取红包领取记录列表
export const receiveGetlist = params =>get( BaseUrlNew + "/api/redpacket/activity/receive/getlist",params, 1);
// 删除红包活动
export const activityDel = (params,rpaId) =>post(BaseUrlNew + "/api/redpacket/activity/del/"+rpaId,params, headerDemo, 1, '1.0');
// 结束红包活动
export const activityFinish = (params,rpaId) =>post(BaseUrlNew + "/api/redpacket/activity/finish/"+rpaId,params, headerDemo, 1, '1.0');
// 关闭红包活动
export const activityClose = (params,rpaId) =>post(BaseUrlNew + "/api/redpacket/activity/close/"+rpaId,params, headerDemo, 1, '1.0');
// 开启店铺红包活动
export const activityStart = (params,rpaId) =>post(BaseUrlNew + "/api/redpacket/activity/start/"+rpaId,params, headerDemo, 1, '1.0');
// 获取红包活动支付状态
export const activityGetpaystatus = (params, rpaId) =>get( BaseUrlNew + "/api/redpacket/activity/getpaystatus/"+rpaId,params, 1);



/** ******************** 企业信息 ******************** */

// 获取企业混合信息
export const enterpriseGetinfo = (params, enterpriseId) =>get( BaseUrlNew + "/api/enterprise/getinfo/"+enterpriseId,params, 1);
// 编辑入驻商家信息 和上面入驻企业模块共用



// WEBPACK FOOTER //
// ./src/api/attractInvestment.js